
import { Heart, Github, Twitter, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import LakshBotLogo from './LakshBotLogo';

const Footer = () => {
  return (
    <footer className="py-12 px-6 border-t">
      <div className="container max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center">
              <LakshBotLogo size={24} />
            </div>
            
            <p className="mt-4 text-muted-foreground">
              A sophisticated investment analysis and prediction platform built with 
              elegant design principles and powerful financial analytics. Helping you 
              make smarter, data-driven decisions.
            </p>
            
            <div className="mt-6 flex items-center space-x-4">
              <a href="https://github.com/LakshyaGupta/lakshbot.github.io" className="text-muted-foreground hover:text-foreground transition-colors">
                <Github size={18} />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Twitter size={18} />
              </a>
              <a href="https://lakshbotappi-ycfp2m3tnsbprt5lgskmvp.streamlit.app/" className="text-muted-foreground hover:text-foreground transition-colors">
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold tracking-wide mb-4 uppercase">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Dashboard
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Analysis
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Predictions
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  API Access
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold tracking-wide mb-4 uppercase">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  API
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-6 border-t text-center text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} LakshBot. All rights reserved.
          </p>
          <p className="mt-2 flex items-center justify-center">
            Crafted with
            <Heart size={14} className={cn("text-red-500 mx-1")} />
            for an intuitive investment experience
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
